enum ArriereHeaders {
  Authorization = 'Authorization',
  Teammate = 'x-teammate',
}

/** The teammate email is sent when known; the session token alone authenticates the request. */
export const buildArriereAuthHeaders = ({
  email,
  token,
}: {
  email: string | null
  token: string
}) => ({
  [ArriereHeaders.Authorization]: `Bearer ${token}`,
  ...(email ? { [ArriereHeaders.Teammate]: email } : {}),
})
